"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _object = require("lodash/object");

var _utils = require("../../utils");

var prepareInputs = function prepareInputs(reviewData, inputs) {
  var inputsData = {};
  inputs.forEach(function (input) {
    var key = input.key,
        dataPath = input.dataPath,
        type = input.type,
        maxCharInline = input.maxCharInline,
        maxLine = input.maxLine,
        textTransform = input.textTransform,
        format = input.format;

    switch (type) {
      case 'string':
        inputsData[key] = (0, _utils.splitToLine)((0, _utils.ConvertCase)((0, _utils.NormalizeText)((0, _object.get)(reviewData, dataPath, '')), textTransform), maxLine, maxCharInline).join('\\r');
        break;

      case 'date':
        inputsData[key] = (0, _utils.dateConvert)((0, _object.get)(reviewData, dataPath, ''), format);
        break;

      default:
        inputsData[key] = (0, _object.get)(reviewData, dataPath, '');
        break;
    }
  });
  return inputsData;
};

var _default = prepareInputs;
exports.default = _default;